// extracted by mini-css-extract-plugin
export default {"logo":"IframeLogin_logo__48iCR","paragraph":"IframeLogin_paragraph__hhgGQ"};